import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'

export const toastConfig = {
  position: 'top-right',
  duration: 12000
}

export default VueToast
